import { Anchor, Box, Group, Stack } from '@mantine/core'
import { AppText } from '../common/ui'
import { Link, useLocation } from 'react-router-dom'
import GunSlopWordmark from '../common/ui/GunSlopWordmark'
import {
  MAIN_CONTENT_HORIZONTAL_GUTTER_PX,
  pathnameUsesMainContentHorizontalGutter
} from './mainContentHorizontalGutter'

const linkSx = {
  color: 'var(--gs-muted)',
  fontFamily: 'DM Sans, sans-serif',
  fontSize: 13,
  lineHeight: 1.4,
  whiteSpace: 'nowrap' as const,
  '&:hover': { color: 'var(--gs-accent)' }
}

export default function AppFooter () {
  const { pathname } = useLocation()
  const shellHasGutter = pathnameUsesMainContentHorizontalGutter(pathname)
  const horizontalPad = shellHasGutter ? 0 : MAIN_CONTENT_HORIZONTAL_GUTTER_PX

  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid var(--gs-border)',
        marginTop: 48,
        paddingTop: 24,
        paddingBottom: 28,
        paddingLeft: horizontalPad,
        paddingRight: horizontalPad,
        boxSizing: 'border-box',
        width: '100%'
      }}
    >
      <Stack spacing={14} align="center">
        <Group
          spacing="md"
          position="center"
          sx={{
            flexWrap: 'wrap',
            justifyContent: 'center',
            rowGap: 10,
            columnGap: 20,
            maxWidth: 520,
            width: '100%'
          }}
        >
          <Anchor component={Link} to="/privacy" sx={linkSx}>
            Privacy Policy
          </Anchor>
          <Anchor component={Link} to="/terms" sx={linkSx}>
            Terms of Service
          </Anchor>
          <Anchor component={Link} to="/guidelines" sx={linkSx}>
            Community Guidelines
          </Anchor>
          <Anchor href="mailto:privacy@gunslop.com" sx={linkSx}>
            Privacy Contact
          </Anchor>
        </Group>
        <AppText
          component={Link}
          to="/about"
          sx={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: 12,
            color: 'var(--gs-muted)',
            textDecoration: 'none',
            textAlign: 'center',
            lineHeight: 1.4,
            '&:hover': { color: 'var(--gs-accent)' }
          }}
        >
          © {new Date().getFullYear()}{' '}
          <GunSlopWordmark size="xs" inline sx={{ color: 'inherit' }} />
        </AppText>
      </Stack>
    </Box>
  )
}
